import React from 'react';
import { MainVideoTrack } from './main-video-track.component';

type MainParticipantProps = {
  sessionDetails?: string;
};

export const MainParticipant: React.FC<MainParticipantProps> = ({ sessionDetails = '' }) =>
  <MainVideoTrack sessionDetails={sessionDetails} />;
